import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility per combinare classi Tailwind
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Genera un ID univoco (mock MongoDB ObjectId)
 */
export function generateId() {
  return Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
}

/**
 * Delay helper per simulare chiamate async
 */
export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * Formatta data in formato leggibile
 */
export function formatDate(date) {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('it-IT', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

/**
 * Match semplice di query per mockDb
 */
export function matchesQuery(doc, query) {
  if (!query || Object.keys(query).length === 0) return true;
  
  return Object.entries(query).every(([key, value]) => {
    if (typeof value === 'object' && value !== null) {
      // Query operators tipo {$eq: value}
      return Object.entries(value).every(([op, opValue]) => {
        if (op === '$eq') return doc[key] === opValue;
        if (op === '$ne') return doc[key] !== opValue;
        if (op === '$in') return opValue.includes(doc[key]);
        return true;
      });
    }
    return doc[key] === value;
  });
}
